import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GenderTypeEnum } from '../../../../models/users/enum/gender-type';
import { PronounTypeEnum } from '../../../../models/users/enum/pronoun-type.enum';
import { MemberUser } from '../../../../models/users/dto/member-user';
import { MemberSIN } from '../../../../models/users/dto/member-sin';
import { CANADA_COUNTRY_CODE } from '../../../../consts/consts';
import { AddressFormGroup } from '../../../../forms/address-form-group';
import { AddressFormFactory } from '../../../../form-factories/address-form-factory';

export type MemberPersonalInformationOnboardingFormGroup = FormGroup<{
  firstName: FormControl<string | null>;
  middleName: FormControl<string | null>;
  lastName: FormControl<string | null>;
  preferredName: FormControl<string | null>;
  birthDate: FormControl<string | null>;
  socialInsuranceNumber: FormControl<string | null>;
  genderId: FormControl<GenderTypeEnum | null>;
  pronounId: FormControl<PronounTypeEnum | null>;
  primaryPhoneNumber: FormControl<string | null>;
  primaryPhoneNumberCountryCode: FormControl<string | null>;
  secondaryPhoneNumber: FormControl<string | null>;
  secondaryPhoneNumberCountryCode: FormControl<string | null>;
  address: AddressFormGroup;
}>;

export function buildMemberPersonalInformationOnboardingFormGroup(
  u: MemberUser,
  sin: MemberSIN
): MemberPersonalInformationOnboardingFormGroup {
  return new FormGroup({
    firstName: new FormControl({ value: u.firstName ?? '', disabled: true }, [Validators.required]),
    middleName: new FormControl({ value: u.middleName ?? '', disabled: true }, [Validators.required]),
    lastName: new FormControl({ value: u.lastName ?? '', disabled: true }, [Validators.required]),
    preferredName: new FormControl(u.preferredName ?? null),
    birthDate: new FormControl({ value: u?.birthDate, disabled: true }, [Validators.required]),
    socialInsuranceNumber: new FormControl({ value: sin?.socialInsuranceNumber ?? '', disabled: true }, [
      Validators.required
    ]),
    genderId: new FormControl(u.genderId ?? null, { validators: [Validators.required] }),
    pronounId: new FormControl(u.pronounId ?? null),
    primaryPhoneNumber: new FormControl(u.primaryPhoneNumber ?? '', { validators: [Validators.required] }),
    primaryPhoneNumberCountryCode: new FormControl(u.primaryPhoneNumberCountryCode ?? CANADA_COUNTRY_CODE, {
      validators: [Validators.required]
    }),
    secondaryPhoneNumber: new FormControl(u.secondaryPhoneNumber ?? ''),
    secondaryPhoneNumberCountryCode: new FormControl(u.secondaryPhoneNumberCountryCode ?? CANADA_COUNTRY_CODE, {}),
    address: AddressFormFactory.createAddressForm(u.address)
  });
}
